import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Card, H3, H6, Button, Classes, Intent, FormGroup, InputGroup } from '@blueprintjs/core';
import CorpusHeader from '../common/CorpusHeader';
import SavedResultsTable from './SavedResultsTable';
import { Dialog } from '@blueprintjs/core';

//import { refreshSignIn } from '../../../utils'


class SavedResults extends React.PureComponent {

  state = {
    selectedResults: null,
    isOpenModal: false,
    waitingForVocExtraction:false,
    filter:"",
  };

  toggleModal = () => {
    this.setState(prevState => ({ isOpenModal: !prevState.isOpenModal }));
  }

  loadResults = () => {
    // console.log("Load result",this.state.selectedResults);
    this.props.loadSavedResults(this.state.selectedResults.file,this.state.selectedResults.summary.lang,this.state.selectedResults.summary.query);
  }

  handleSelectRow = (selectedResults) => {
    this.setState({ selectedResults: selectedResults });
  }


  handleOnConfirmSuppressResults =() => {
    this.toggleModal();
    const endpoint = '/delete_files.ajax.php';

    console.log(this.state.selectedResults);
    const data={ 
      type:'results',
      name:[this.state.selectedResults.file.replace(/.json$/,"")],
    };

    fetch(
      process.env.REACT_APP_API_BASE + endpoint, {
        credentials: process.env.REACT_APP_CREDENTIALS,
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        body: JSON.stringify(data),
      })
      .then((res) => {
        if (res.status !== 200) {
          console.log(`Issue reaching ${endpoint}`);
          return;
        }
        res.json().then((data) => {
          this.props.refreshSavedData();
          this.setState({ selectedResults: null });
        })
      })
      .catch(() => {
        console.log(`Network error when trying to fetch ${endpoint}`);
      })
  };
  

  render() {
    const { selectedResults, isOpenModal } = this.state;
    const { t, savedResults } = this.props;
    //const langFormat = Cookies.get(FRONT_USER_LANG_COOKIE_NAME)==="en"? "en-EN":"fr-FR";

    const items=[];
    if (selectedResults) {
      //console.log(selectedResults.summary);
      for (const key of Object.keys(selectedResults.summary).sort()) {
        if (selectedResults.summary[key]) { 
          items.push(
            <li key={key}>{key} : {selectedResults.summary[key].toString()}</li>
          );
        }
      }
    }
    
 
    return (
      <>
        <CorpusHeader
          title={t('savedResultsHeader')}
        />
        
        <FormGroup 
          label={t('filter')} 
          labelFor="filter" 
          inline={true}
          helperText={t('filterHelp')}
        >
          <InputGroup
            id="filter"
            value={this.state.filter}
            onChange={(e) => this.setState({ filter: e.target.value })}
          />
        </FormGroup>
        <div className="flex">

          <div className="flex-two-panels">
            <div className="padding-1-rem">
              {savedResults &&
                <SavedResultsTable
                  savedResults={savedResults}
                  onSelectRow={this.handleSelectRow}
                  filter={this.state.filter}
                  csvDelimiter={this.props.csvDelimiter}
                />
              }
            </div>
          </div>
          <div className="flex-two-panels">
            <div className="padding-1-rem">
              {selectedResults &&
                <Card elevation={2}>
                  <H3 className="margin-bottom-1-5rem">{selectedResults.file}</H3>
                  <H6>{t('recapInfo')}</H6>
                  <ul>
                    {items}
                  </ul>
  
                  <br/>
                  
                  <Button text={t('reload')} onClick={this.loadResults} />&nbsp;&nbsp;
                                    
                  <Button text={t('suppress')} intent="danger" onClick={this.toggleModal} />

                  


                 </Card>
              }
            </div>
          </div>
        </div>
       
        {selectedResults &&
          <Dialog
            isOpen={isOpenModal}
            onClose={this.toggleModal}
            title={t('suppress')+" «"+selectedResults.file+"»"}
            style={{'width': '400px'}}  // 400px seems a good deal
          >
            <div className={Classes.DIALOG_BODY}>
              {t('suppressResultsExplanation')}
            </div>
            <div className={Classes.DIALOG_FOOTER}>
              <div className={Classes.DIALOG_FOOTER_ACTIONS}>

                <Button onClick={this.toggleModal}>Close</Button>

                <Button
                    onClick={this.handleOnConfirmSuppressResults}
                    intent={Intent.DANGER}
                >
                    {t('confirmSuppressing')}
                </Button>
              </div>
            </div>

          </Dialog>
        }
      </>
    );
  }
}

SavedResults.propTypes = {
  loadSavedResults: PropTypes.func,
  savedResults: PropTypes.array,
  refreshSavedData: PropTypes.func,
  csvDelimiter:PropTypes.string,
};

export default withTranslation()(SavedResults);
